import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import UserDatabases from '@Services/UserDatabases';
import { Banner } from '@els/els-react--banner';
import { ButtonWithIcon } from '@els/els-react--button';
import HeaderContainerService from './HeaderContainerService';
import { checkChildrenValues, getUnsupportedNlqCombinationReason } from './disableButtonHelper';

import './HeaderContainer.scss';

function HeaderContainer({ nodesList, properties }) {
  const dbs = UserDatabases.getUserSearchContexts();
  const disabledState = checkChildrenValues(nodesList);
  const invalidCombinationReason = getUnsupportedNlqCombinationReason(nodesList);
  const showInvalidCombinationBanner = !!invalidCombinationReason;
  const warningMessage =
    'Natural Language Document Search can only be combined with Titles, Abstracts & Keywords. Please delete non-TAK querylets.';

  function searchInDb(db) {
    return HeaderContainerService.searchInDb(db, nodesList, properties);
  }

  useEffect(() => {
    HeaderContainerService.init();
  }, []);

  return (
    <div className="qb-header-container" aria-labelledby="qb-header-container-label">
      <Banner type="warn" isVisible={showInvalidCombinationBanner} className="qb-header-container__banner" size="small">
        <strong>Unsupported field combination,</strong> {warningMessage}
      </Banner>
      <div className="qb-header-container__actions">
        <span id="qb-header-container-label" className="qb-header-container__label">
          Search in:
        </span>
        <div className="qb-header-container__button">
          {dbs &&
            dbs.length > 0 &&
            dbs.map((db) => (
              <ButtonWithIcon
                iconRight
                key={db.serverAlias}
                aria-label={`Search in ${db.displayName}`}
                data-e2e={`querybuilder-${db.displayName?.toLowerCase()}-button`}
                disabled={disabledState || showInvalidCombinationBanner}
                htmlType="submit"
                sprite="ChevronRight"
                onClick={() => {
                  searchInDb(db);
                }}>
                {db.displayName}
              </ButtonWithIcon>
            ))}
        </div>
      </div>
    </div>
  );
}

HeaderContainer.propTypes = {
  nodesList: PropTypes.array,
  properties: PropTypes.array,
};
export default HeaderContainer;
